import React, { useCallback, useState } from 'react';

import { useDefaultValueWatcher } from '../../../hooks/useDefaultValueWatcher';
import { useOnChange } from '../../../hooks/useOnChange';
import InputField from '../../Inputs/TextField/TextField';

// THIS FILTER NOT USED ANYMORE SINCE RRFD-488
interface Props {
  root?: boolean;
  defaultValue: any;
  onChange: (value: any) => void;
  active: boolean;
}

const TextFieldFilterInput: React.FC<Props> = React.memo(
  ({ onChange, root, active, defaultValue = { value: '' } }) => {
    const [state, setState] = useState<any>(defaultValue);
    const onComponentChanged = useCallback((state) => onChange(state), [onChange]);

    useDefaultValueWatcher({ defaultValue, state, setState });
    useOnChange(onComponentChanged, state, root);

    return (
      <>
        {active ? (
          <InputField
            value={state.value}
            onChange={(value) => {
              setState({
                ...state,
                value: value,
              });
            }}
          />
        ) : state.value ? (
          <p>{state.value}</p>
        ) : null}
      </>
    );
  },
);

export default TextFieldFilterInput;
